import { memo } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { Typography } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../theme/palette";
import { OVERRIDES_PLAN_TYPE, PICKUP_PLAN_TYPE } from "../../consts/planTypes";

import { getMatrixProfileType } from "../../reducers/matrixProfile/selectors";
import { artificialPostcodeInEditSelector } from "../../reducers/depot/selectors";

import { AffectedPostcodesList } from "./AffectedPostcodeList";
import { RouteWithVolume } from "./RouteWithVolume";
import { PostcodeLabel } from "../../components/Layers/RouteLabelLayer/PostcodeLabel";
import { View } from "../View";

const useStyles = makeStyles(({ typography }) => ({
  routesImpactedText: {
    color: palette.typography.white.solid,
    display: "inline",
    fontSize: "12px",
    marginRight: "10px",
  },
  left10: {
    marginLeft: "10px",
  },
}));

export const ImpactedDetails = memo(() => {
  const styles = useStyles();
  const profileType = useSelector(getMatrixProfileType);
  const artificialPostcodeEdit = useSelector(artificialPostcodeInEditSelector);

  if ([OVERRIDES_PLAN_TYPE, PICKUP_PLAN_TYPE].includes(profileType))
    return (
      <>
        <Typography className={clsx(styles.routesImpactedText, styles.left10)}>
          Affected Postcodes
        </Typography>
        <AffectedPostcodesList />
      </>
    );
  else if (artificialPostcodeEdit)
    return (
      <>
        <Typography className={clsx(styles.routesImpactedText, styles.left10)}>
          Affected Postcode
        </Typography>
        <View>
          <PostcodeLabel {...artificialPostcodeEdit} />
        </View>
      </>
    );
  else
    return (
      <>
        <Typography className={clsx(styles.routesImpactedText, styles.left10)}>
          Routes Impacted
        </Typography>
        <RouteWithVolume />
      </>
    );
});
